var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PO_System",
    "data-name": "PO System",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 26,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M31.367,13.733H38.7a.367.367,0,0,0,0-.733H31.367a.367.367,0,0,0,0,.733Z",
    transform: "translate(-18.842 -8.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M41.867,17h-5.5a.367.367,0,0,0,0,.733h5.5a.367.367,0,0,0,0-.733Z",
    transform: "translate(-21.954 -10.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M24.794,6.8h-.8v-2a.4.4,0,0,0-.4-.4h-2.4v-2a.4.4,0,0,0-.4-.4H4a.4.4,0,0,0-.4.4V6.8H3.47A1.54,1.54,0,0,0,2,8.4V24.364A1.572,1.572,0,0,0,3.494,26H24.558a1.544,1.544,0,0,0,1.436-1.632V8a1.2,1.2,0,0,0-1.2-1.2ZM6.4,4.8V6.823A1.548,1.548,0,0,0,5.2,8.4V23.6H4.4V2.8h16V4.4H6.8A.4.4,0,0,0,6.4,4.8Zm9.2,18.8a5.6,5.6,0,1,1,5.6-5.6,5.6,5.6,0,0,1-5.6,5.6Zm7.6-13.6H14.94a.332.332,0,0,1-.228-.092l-2.968-2.8a1.132,1.132,0,0,0-.776-.308H7.2V5.2h16Z",
    transform: "translate(-1.997 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M28.4,30a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,28.4,30Zm3.436,5.757-.55.953a.367.367,0,0,1-.469.15l-.887-.4a2.566,2.566,0,0,1-.521.3l-.1.979a.367.367,0,0,1-.367.33h-1.1a.367.367,0,0,1-.367-.33l-.1-.979a2.566,2.566,0,0,1-.521-.3l-.887.4a.367.367,0,0,1-.469-.15l-.55-.953a.367.367,0,0,1,.1-.48l.8-.576a2.358,2.358,0,0,1,0-.6l-.8-.576a.367.367,0,0,1-.1-.48l.55-.953a.367.367,0,0,1,.469-.15l.887.4a2.566,2.566,0,0,1,.521-.3l.1-.979a.367.367,0,0,1,.367-.33h1.1a.367.367,0,0,1,.367.33l.1.979a2.566,2.566,0,0,1,.521.3l.887-.4a.367.367,0,0,1,.469.15l.55.953a.367.367,0,0,1-.1.48l-.8.576a2.358,2.358,0,0,1,0,.6l.8.576A.367.367,0,0,1,31.836,35.757Z",
    transform: "translate(-14.759 -18.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M33.235,37.318a1.833,1.833,0,0,0,0-.77.367.367,0,0,1,.143-.367l.708-.513-.216-.367-.8.367a.367.367,0,0,1-.4-.062,1.786,1.786,0,0,0-.667-.389.367.367,0,0,1-.253-.312L31.669,34h-.433l-.088.876a.367.367,0,0,1-.253.312,1.786,1.786,0,0,0-.667.389.367.367,0,0,1-.4.062l-.8-.367-.216.367.708.513a.367.367,0,0,1,.143.367,1.833,1.833,0,0,0,0,.77.367.367,0,0,1-.143.367l-.708.513.216.367.8-.367a.367.367,0,0,1,.4.062,1.786,1.786,0,0,0,.667.389.367.367,0,0,1,.253.312l.088.935h.433l.088-.876a.367.367,0,0,1,.253-.312,1.786,1.786,0,0,0,.667-.389.367.367,0,0,1,.4-.062l.8.367.216-.367-.708-.513A.367.367,0,0,1,33.235,37.318Zm-1.782.715a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,31.453,38.033Z",
    transform: "translate(-17.812 -20.815)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.363,
    cy: 0.367,
    rx: 0.363,
    ry: 0.367,
    transform: "translate(13.277 15.752)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoSystem);
export default __webpack_public_path__ + "static/media/POSystem.322e15a6d78a2577a23a19f2ffe1289a.svg";
export { ForwardRef as ReactComponent };